import { useEffect, useState, useCallback } from 'react';
import ApiDatabase from '../../../../../../server';
import { toPresignedDocs } from './presignDocs';

/**
 * Hook pour gérer le chargement des fichiers dans les modaux admin
 * @param {object} params
 * @param {string} params.token - Token d'authentification
 * @param {string} params.adminUserId - ID de l'utilisateur admin
 * @param {string} params.adminType - Type de document
 * @param {string} params.adminFileName - Nom du fichier (optionnel)
 * @param {boolean} params.enabled - Activer le chargement (défaut: true)
 * @returns {object} { docs, isWaiting, refetch }
 */
const useAdminModalFiles = ({ 
  token, 
  adminUserId, 
  adminType, 
  adminFileName = '',
  enabled = true 
}) => {
  const [docs, setDocs] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);

  const fetchFiles = useCallback(() => {
    if (!adminUserId || !adminType) {
      setDocs([]);
      setIsWaiting(false);
      return;
    }

    setIsWaiting(true);

    ApiDatabase.postPresignFiles(
      {
        token,
        idUser: adminUserId,
        type: adminType,
        fileName: adminFileName || '',
      },
      (data) => {
        const docsFromLinks = toPresignedDocs(data);
        setIsWaiting(false);
        setDocs(docsFromLinks);
      },
      (err) => {
        console.log(err);
        setDocs([]);
        setIsWaiting(false);
      },
      {
        abortKey: `admin/presignFiles/main/${adminUserId}/${adminType}/${adminFileName || ''}`,
      }
    );
  }, [token, adminUserId, adminType, adminFileName]);

  useEffect(() => {
    if (enabled) {
      fetchFiles();
    }
  }, [enabled, fetchFiles]);

  return { docs, isWaiting, refetch: fetchFiles };
};

export default useAdminModalFiles;
